<template>
  <MCVClientDataSetList />
</template>

<script>
import MCVClientDataSetList from '@/modules/mcvClientDataSet/components/list';

export default {
  name: 'ClientDataSets',
  components: {
    MCVClientDataSetList,
  },
};
</script>
